<template>
  <div class="menuFrame">
    <loading :active.sync="isLoading"></loading>

    <div id="track">
      <div class="d-flex justify-content-between">
        <div>
          <a href="/ExhibitorServiceTW/en">Exhibition List</a><span>/</span> <em name="Exhibition"></em>
          <span>/</span>Invitation EDM
        </div>
        <div>
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
      </div>
    </div>
    <!-- track end -->
    <!-- article -->
    <div class="MbDevice">
      <div class="homeLeft mt-5">
        <div class="UserAccount ml-1">
          <span class="bold">Account :</span>
          <span> {{ UserId }}</span>
        </div>
        <hr />
        <div class="expoLogo"><img :src="ExhLogo" width="100%" /></div>
        <div class="expoInfo">
          <p class="bold" name="Exhibition"></p>
          <p>{{ ExhBegin }} - {{ ExhEnd }}</p>
          <p>{{ eExhVenue }}</p>
        </div>
        <p class="clear"></p>
      </div>
    </div>

    <div class="articleEn">
      <div>
        <div class="PcDevice">
          <div class="contentBoxStatus py-3">
            <div class="d-flex align-items-center justify-content-around">
              <div
                v-for="(item, index) in MenuInvitation"
                :key="index"
                class="btn btn-white py-2 px-4"
                style="border-radius: 20px; border-color: #d9d9d9"
                @click="InviteLink(item.Url)"
              >
                <span
                  class="font-weight-bold text-primary"
                  style="font-size: 16px"
                  v-if="item.MenuName == 'Invitation EDM'"
                >
                  <i class="fas fa-caret-right"></i> {{ item.MenuName }}
                </span>
                <span v-else> <i class="fas fa-caret-right"></i> {{ item.MenuName }} </span>
              </div>
            </div>
          </div>
          <div class="my-3"></div>
        </div>
        <div class="contentBox">
          <!-- left -->
          <div class="proLeft NoShowInMobile align_c">
            <img src="@/assets/images/iconInvite.svg" width="100%" />
          </div>
          <!-- left end -->
          <!-- right -->
          <div class="proRight">
            <div class="MbDevice">
              <div class="d-flex justify-content-between align-items-center">
                <!-- <div>
                  <h1><img src="@/assets/images/iconInvite.svg" width="35px" class="mb-2" /> Invitation EDM</h1>
                </div> -->

                <div class="d-flex align-items-center">
                  <div>
                    <img src="@/assets/images/iconInvite.svg" width="35px" class="mt-1 mr-1" />
                  </div>
                  <div>
                    <h1>Invitation EDM</h1>
                  </div>
                </div>
                <div class="mb-2">
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      <span class="border py-1 px-3">
                        <i class="fas fa-ellipsis-h"></i>
                      </span>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="(item, index) in MenuInvitation" :key="index">
                        <span class="MbListGray" @click="InviteLink(item.Url)"> {{ item.MenuName }} </span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
            <div class="PcDevice">
              <h1>Invitation EDM</h1>
            </div>
            <p class="my-3">&nbsp;</p>
            <p class="mb-1">
              You can generate e-invitation (EDM). You can forward the EDM or copy its URL to your clients. Those
              invited would be able to visit the exhibition once they have finished their Visiting Eligibility
              Application.
            </p>

            <p class="my-3">&nbsp;</p>
            <ol class="number">
              <li>Once the customer finished registration, it will be included in the quota calculation.</li>
              <li>If you need more quota please contact our sales</li>
              <li>
                * The application is available until <span class="red"><span name="CloseDay"></span> 23:59</span>, it
                will be unavailable during the exhibition.
              </li>
              <li class="Caution">
                <span class="red"><span name="Caution"></span></span>
              </li>
            </ol>
            <p class="lightLine">&nbsp;</p>
            <h3>Status</h3>
            <p class="my-3">&nbsp;</p>
            <p>The following are the status of your clients registered.</p>
            <p class="my-3">&nbsp;</p>
            <div class="grayBG">
              <p>Used：<span name="InvitationUsed"></span></p>
            </div>

            <div class="OpenBothInvite">
              <p class="lightLine">&nbsp;</p>
              <h3>Send E-Invitation</h3>
              <p class="my-3">&nbsp;</p>
              <p>Please forward the E-Invitation or copy the E-invitation URL to your VIP clients!</p>
              <p class="my-3">&nbsp;</p>
              <!-- tw -->

              <div class="ShowPhyInvite">
                <h4 class="mb-4">
                  <span style="padding-bottom: 1px; border-bottom: 1px solid rgb(0, 0, 0)">
                    Physical exhibition E-Invitation
                  </span>
                </h4>

                <div class="left">
                  <div class="grayBG">
                    <p class="bold">Physical exhibition E-Invitation (Chinese)</p>
                    <p name="Code"></p>
                    <input name="Code" class="hiddenInput" type="text" />
                    <p class="divider">&nbsp;</p>

                    <div class="btnStyle mr-2" @click.prevent="SendRegMailEn('tw', 'Physical')">Send</div>
                    <input type="button" value="Copy" class="btnStyle copyURL" />
                  </div>
                </div>
                <!-- tw end -->
                <!-- en -->
                <div class="right">
                  <div class="grayBG">
                    <p class="bold">Physical exhibition E-Invitation (English)</p>
                    <p name="CodeEn"></p>
                    <input name="CodeEn" class="hiddenInput" type="text" />
                    <p class="divider">&nbsp;</p>

                    <div class="btnStyle mr-2" @click.prevent="SendRegMailEn('en', 'Physical')">Send</div>
                    <input type="button" value="Copy" class="btnStyle copyURL" />
                  </div>
                </div>
              </div>

              <p class="clear"></p>
              <div class="ShowOnlineInvite">
                <h4 class="my-4">
                  <span style="padding-bottom: 1px; border-bottom: 1px solid rgb(0, 0, 0)">
                    Online exhibition E-Invitation
                  </span>
                </h4>

                <div class="left">
                  <div class="grayBG">
                    <p class="bold">Online exhibition E-Invitation (Chinese)</p>
                    <p name="OnlineCode"></p>
                    <input name="OnlineCode" class="hiddenInput" type="text" />
                    <p class="divider">&nbsp;</p>

                    <div class="btnStyle mr-2" @click.prevent="SendRegMailEn('tw', 'Online')">Send</div>
                    <!-- <input type="submit" value="發送中文版" class="btnStyle"> -->
                    <input type="button" value="Copy" class="btnStyle copyURL" />
                  </div>
                </div>
                <!-- tw end -->
                <!-- en -->
                <div class="right">
                  <div class="grayBG">
                    <p class="bold">Online exhibition E-Invitation (English)</p>
                    <p name="OnlineCodeEn"></p>
                    <input name="OnlineCodeEn" class="hiddenInput" type="text" />
                    <p class="divider">&nbsp;</p>

                    <div class="btnStyle mr-2" @click.prevent="SendRegMailEn('en', 'Online')">Send</div>
                    <input type="button" value="Copy" class="btnStyle copyURL" />
                  </div>
                </div>
              </div>
            </div>

            <!-- en end -->
            <p class="clear"></p>
          </div>
          <p class="clear"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'
  import axios from 'axios'

  export default {
    metaInfo() {
      return {
        title: 'Invitation EDM - ExhibitorServiceTW',
      }
    },

    data() {
      return {
        UserId: '',
        CSRF_Token: '',
        RegNo: '',
        date: '',
        lang: 'en',
        openOnlineInvite: '',
        openPhyInvite: '',
        hasOnlineExh: '',
        hasPhyExh: '',
        MenuInvitation: [],
        ExhLogo: '',
        ExhBegin: '',
        ExhEnd: '',
        ExhVenue: '',
        eExhVenue: '',
      }
    },
    methods: {
      InviteLink(Url) {
        const vm = this
        if (vm.lang == 'tw') {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/${Url}?no=${vm.RegNo}`
        } else {
          document.location.href = `https://www.chanchao.com.tw/ExhibitorServiceTW/en/${Url}?no=${vm.RegNo}`
        }
      },
      SendRegMail(lang, type) {
        const vm = this
        const url = `/apiExhibitors/SendInviteReg/`
        const info = {
          CSRF: vm.CSRF_Token,
          E_Lang: lang,
          RegNo: vm.RegNo,
          Type: type,
        }

        // console.log(info)

        axios.post(url, info).then(function (response) {
          // console.log(response)

          if (type == 'Physical') {
            if (response.data.Code == 200) {
              alert('實體展電子邀請函 (EDM) 已成功寄出至您參展資訊中所留的Email，歡迎多加廣發給您的重要客戶。')
            } else if (response.data.Code == 251 || response.data.Code == 500) {
              alert('系統忙碌，請稍後再試！')
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`
            } else if (response.data.Code == 253) {
              alert('Email發生錯誤！')
            }
          } else if (type == 'Online') {
            if (response.data.Code == 200) {
              alert('線上展電子邀請函 (EDM) 已成功寄出至您參展資訊中所留的Email，歡迎多加廣發給您的重要客戶。')
            } else if (response.data.Code == 251 || response.data.Code == 500) {
              alert('系統忙碌，請稍後再試！')
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`
            } else if (response.data.Code == 253) {
              alert('Email發生錯誤！')
            }
          }
        })
      },

      SendRegMailEn(lang, type) {
        const vm = this
        const url = `/apiExhibitors/SendInviteReg/`
        const info = {
          CSRF: vm.CSRF_Token,
          E_Lang: lang,
          RegNo: vm.RegNo,
          Type: type,
        }

        // console.log(info)

        axios.post(url, info).then(function (response) {
          // console.log(response)

          if (type == 'Physical') {
            if (response.data.Code == 200) {
              alert(
                'Physical exhibition E-invitation has been sent to your email. You can send it to your VIP clients.'
              )
            } else if (response.data.Code == 251 || response.data.Code == 500) {
              alert('System is busy, please try again later.')
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`
            } else if (response.data.Code == 253) {
              alert('Email error！')
            }
          } else if (type == 'Online') {
            if (response.data.Code == 200) {
              alert('Online exhibition E-invitation has been sent to your email. You can send it to your VIP clients.')
            } else if (response.data.Code == 251 || response.data.Code == 500) {
              alert('System is busy, please try again later.')
            } else if (response.data.Code == 252) {
              document.location.href = `https://www.chanchao.com.tw/`
            } else if (response.data.Code == 253) {
              alert('Email error！')
            }
          }
        })
      },
    },

    created() {
      const vm = this

      //取得語系

      var lang = 'en'

      //CSRF_Token
      axios.get('https://www.chanchao.com.tw/apiExhibitors/CSRF_Token').then((response) => {
        vm.CSRF_Token = response.data
      })

      axios.get(`https://www.chanchao.com.tw/apiExhibitors/UserID`).then((response) => {
        vm.UserId = response.data
      })

      //url取出展碼
      let currentUrl = location.href
      vm.RegNo = currentUrl.split('no=')[1]
      var RegNo = currentUrl.split('no=')[1]

      //取得當前時間
      let theDate = new Date()
      vm.date = `${theDate.getFullYear()}/${theDate.getMonth() + 1}/${theDate.getDate()}`

      //取得是否開啟線上展權限
      axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibition/${vm.RegNo}?lang=${vm.lang}`).then((response) => {
        // console.log(response.data.Data)

        vm.ExhLogo = `//www.ccie.com.tw/exhibition/images/exlogo/${response.data.Data.ExhLogo}`
        vm.ExhBegin = response.data.Data.ExhBegin
        vm.ExhEnd = response.data.Data.ExhEnd
        vm.ExhVenue = response.data.Data.ExhVenue
        vm.eExhVenue = response.data.Data.eExhVenue

        vm.openOnlineInvite = response.data.Data.OnlineExpo_Archived
        vm.openPhyInvite = response.data.Data.PhysicalExpo_Archived

        //判定是否開放兩展邀請函

        if (vm.openOnlineInvite == 1 || vm.openPhyInvite == 1) {
          $('.OpenBothInvite').addClass('ShowInviteTopic')
          $('.OpenBothInvite').removeClass('HideInviteTopic')
        } else {
          $('.OpenBothInvite').addClass('HideInviteTopic')
          $('.OpenBothInvite').removeClass('ShowInviteTopic')
        }

        //取得是否有線上展
        axios.get(`https://www.chanchao.com.tw/apiExhibitors/Exhibitor/${vm.RegNo}`).then((response) => {
          // console.log(response.data.Data)
          vm.hasOnlineExh = response.data.Data.Virtual
          vm.hasPhyExh = response.data.Data.physical

          //判定開放實體邀請函

          if (vm.openPhyInvite == 1 && vm.hasPhyExh == 1) {
            $('.ShowPhyInvite').addClass('ShowInviteTopic')
            $('.ShowPhyInvite').removeClass('HideInviteTopic')
          } else {
            $('.ShowPhyInvite').addClass('HideInviteTopic')
            $('.ShowPhyInvite').removeClass('ShowInviteTopic')
          }
          //判定開放線上展邀請函

          if (vm.openOnlineInvite == 1 && vm.hasOnlineExh == 1) {
            $('.ShowOnlineInvite').addClass('ShowInviteTopic')
            $('.ShowOnlineInvite').removeClass('HideInviteTopic')
          } else {
            $('.ShowOnlineInvite').addClass('HideInviteTopic')
            $('.ShowOnlineInvite').removeClass('ShowInviteTopic')
          }
        })
      })

      //取得邀請選單
      axios
        .get(`https://www.chanchao.com.tw/apiExhibitors/MenuInvitation/${vm.RegNo}?lang=${vm.lang}`)
        .then((response) => {
          // console.log(response.data.Data)

          vm.MenuInvitation = response.data.Data
        })

      // $.ajaxSettings.async = false; //關閉非同步執行
      //RegNo

      $.getJSON('/apiExhibitors/Exhibition/' + RegNo, { lang: lang }, function (data) {
        //close day 展覽前一天23:59

        // console.log(data)

        var CloseDay = new Date(data.Data.ExhBegin)
        CloseDay.setDate(CloseDay.getDate() - 1)
        $('[name="CloseDay"]').text(formatDate(CloseDay))

        function formatDate(date) {
          var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear()
          if (month.length < 2) month = '0' + month
          if (day.length < 2) day = '0' + day
          return [year, month, day].join('/')
        }

        if (lang == 'tw') {
          if (data.Data.Caution == '') {
            $('.Caution').addClass('HideCaution')
          } else {
            $('.Caution').addClass('ShowCaution')
            $('[name="Caution"]').text(data.Data.Caution)
          }
        } else {
          if (data.Data.eCaution == '') {
            $('.Caution').addClass('HideCaution')
          } else {
            $('.Caution').addClass('ShowCaution')
            $('[name="Caution"]').text(data.Data.eCaution)
          }
        }

        var OnlineExpoCode = data.Data.exhcode
        if (OnlineExpoCode == '9864D87B9B73E6DE48B0D75EE3475027') {
          $('.laserExpo').addClass('ShowlaserExpo')
          $('.laserExpo').removeClass('HidelaserExpo')
        } else {
          // console.log('none')
        }

        //get Exhibitor data
        $.getJSON('/apiExhibitors/Exhibitor/' + RegNo, function (data) {
          // console.log(data)
          var Company_Code = data.Data.Company_Code
          var AppNo = data.Data.AppNo

          //get invitation data
          $.getJSON('/apiExhibitors/InvitationPreReg/' + RegNo, function (data) {
            // console.log(data)
            $('[name="InvitationUsed"]').text(data.Data.InvitationUsed) //已使用

            //tw URL
            let Code =
              'https://www.chanchao.com.tw/visitorInvitation/edm_reg.asp?code=' + Company_Code + '&sno=' + AppNo
            $('[name="Code"]').text(Code).val(Code)
            //en URL
            let CodeEn =
              'https://www.chanchao.com.tw/en/visitorInvitation/edm_reg.asp?code=' + Company_Code + '&sno=' + AppNo
            $('[name="CodeEn"]').text(CodeEn).val(CodeEn)

            //online tw URL

            let OnlineCode =
              'https://www.chanchao.com.tw/visitorInvitation/edm_reg_onlineexpo.asp?code=' +
              Company_Code +
              '&sno=' +
              AppNo +
              '&rno=' +
              RegNo
            $('[name="OnlineCode"]').text(OnlineCode).val(OnlineCode)

            //online en URL

            let OnlineCodeEn =
              'https://www.chanchao.com.tw/en/visitorInvitation/edm_reg_onlineexpo.asp?code=' +
              Company_Code +
              '&sno=' +
              AppNo +
              '&rno=' +
              RegNo
            $('[name="OnlineCodeEn"]').text(OnlineCodeEn).val(OnlineCodeEn)
          })
        })

        //copy edm URL
        $('.copyURL').click(function () {
          let copyText = $(this).parent().parent().find('.hiddenInput')
          copyText.select()
          document.execCommand('Copy')

          if (vm.lang == 'tw') {
            alert('網址已複製')
          } else {
            alert('URL copied')
          }
        })
      })
      // $.ajaxSettings.async = true; //開啟非同步執行
    },
  }
</script>

<style lang="scss"></style>
